module.exports = __webpack_public_path__ + "static/PBM-48fe3693053d08f790b433a4178794fc.png";